const Form = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-id="treeNode_mktforms_23AssetIcon"
    className="spectrum-Icon_368b34 spectrum-Icon--sizeS_368b34 TreeIconWrapper spectrum-Icon_e2d99e"
    focusable="false"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    fill={'rgb(105, 123, 144)'}
  >
    <defs>
      <symbol id="icon-meue-form" viewBox="0 0 20 20.001">
        <path d="M12.451 3.334V2.222A2.345 2.345 0 009.998 0a2.345 2.345 0 00-2.449 2.222v1.112H5.098v2.222h9.8V3.334zm-1.226 0h-2.45V2.222a1.173 1.173 0 011.223-1.111 1.173 1.173 0 011.226 1.111z"></path>
        <path
          data-name="Main Body"
          d="M17.647 3.333h-1.765v2.976a.592.592 0 01-.588.6H4.705a.592.592 0 01-.588-.6V3.333H2.352a.592.592 0 00-.588.6v15.472a.592.592 0 00.588.6h15.3a.592.592 0 00.588-.6V3.933a.592.592 0 00-.593-.6zM6.47 15.833a.592.592 0 01-.588.6H4.705a.592.592 0 01-.588-.6v-1.19a.592.592 0 01.588-.6h1.177a.592.592 0 01.588.6zm0-4.762a.592.592 0 01-.588.6H4.705a.592.592 0 01-.588-.6v-1.19a.592.592 0 01.588-.6h1.177a.592.592 0 01.588.6zm8.236 3.869a.3.3 0 01-.294.3H9.117a.3.3 0 01-.294-.3v-.6a.3.3 0 01.294-.3h5.294a.3.3 0 01.294.3zm0-4.762a.3.3 0 01-.294.3H9.117a.3.3 0 01-.294-.3v-.6a.3.3 0 01.294-.3h5.294a.3.3 0 01.294.3z"
        ></path>
      </symbol>
    </defs>
    <use xlinkHref="#icon-meue-form" fill="#697B90"></use>
  </svg>
);

export default Form;
